import React from 'react'
import PropTypes from 'prop-types' 

export const TabContent = ({children, ...props}) => { 
    return (
        <div className="tab-content" {...props}> 
            {children} 
        </div>
    )
}

TabContent.propTypes = {
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.element), PropTypes.element])
}
